var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3292 13.0522C10.1462 13.2352 9.8494 13.2352 9.66634 13.0522L4.88729 8.27312C4.70424 8.09006 4.70424 7.79331 4.88729 7.61025L5.10827 7.38925C5.29132 7.20619 5.58812 7.20619 5.77118 7.38925L9.99778 11.6159L14.2244 7.38925C14.4075 7.20619 14.7042 7.20619 14.8873 7.38925L15.1083 7.61025C15.2913 7.79331 15.2913 8.09006 15.1083 8.27312L10.3292 13.0522Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.e95d62b358ba93179e31b2f140e76719.svg";
export { ForwardRef as ReactComponent };